module.exports = __webpack_public_path__ + "static/media/steam.036f913a.svg";